/**
 *
 * Admin Routes
 *
 */
import {
  AdminSubMenuRoutes,
  adminBasePath,
} from 'modules/Admin/adminPagesConfig';

import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

const AdminAuthPage = lazyLoad(() =>
  import(/*  webpackChunkName: 'adminAuthPage' */ './components/AdminAuth'),
);

const AdminDashPage = lazyLoad(() =>
  import(/*  webpackChunkName: 'adminDashPage' */ './components/AdminDash'),
);

const LegislatorListPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LegislatorListPage' */ './components/LegislatorList'
  ),
);

// routes declaration
export const adminMenuRoutes = [
  {
    component: LegislatorListPage,
    title: 'Legislator Settings',
    path: AdminSubMenuRoutes.LEGISLATOR_LIST,
  },
];

export const adminRoutes = [
  {
    component: AdminAuthPage,
    path: '/admin/auth',
    title: 'Admin',
    needsAuth: true,
  },
  {
    component: Navigate,
    path: adminBasePath,

    replace: true,
    to: adminBasePath + AdminSubMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: AdminDashPage,
    title: 'Admin',
    path: `${adminBasePath}/*`,
    needsAuth: true,
  },
];
